import React, { Component } from 'react';
import { connect } from 'react-redux';
import { removeQuery, zoomToExtent } from '../../gm3/actions/map';
import { setActiveTab, toggleTablePanel } from "../actions/layoutActions";
import Loadable from "react-loadable";
const LoadableResultItem = Loadable({
    loader: () => import("./ResultItem"),
    loading() {
        return <div><i className="fas fa-spinner fa-pulse"></i> Loading...</div>
    }
});
class RenderedResults extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: true
        };
        this.toggleTable = this.toggleTable.bind(this);
        this.toggleContent = this.toggleContent.bind(this);
        this.getContentClass = this.getContentClass.bind(this);
    }
    removeQuery(queryId) {
        this.props.actions.setActiveTab("tools");
        this.props.actions.removeQuery(queryId);
    }
    getExtentForQuery(results) {
        let extent = null;

        for (const path in results) {
            const features = results[path];
            if (features.length > 0) {
                if (extent === null) {
                    extent = features[0].properties.boundedBy.slice();
                }
                for (let i = 1, ii = features.length; i < ii; i++) {
                    const e = features[i].properties.boundedBy;
                    extent[0] = Math.min(extent[0], e[0]);
                    extent[1] = Math.min(extent[1], e[1]);
                    extent[2] = Math.max(extent[2], e[2]);
                    extent[3] = Math.max(extent[3], e[3]);
                }
            }
        }
        return extent;
    }
    toggleContent() {
        // this.props.actions.toggleServiceAccord()
        this.setState((state) => {
            return {
                ...state,
                expanded: !state.expanded
            }
        })
        this.forceUpdate();
    }
    getContentClass() {        
        let cls = "result-container __content";
        let expanded = this.props.isServiceExpanded;
        let tool = this.props.tool;
        if (!this.state.expanded) {
            cls += " __content--collapsed";
        }else{

            if(!expanded || tool === ""){
                cls += " result-container--large";
                
            }else{
                if(tool !== "" && tool === "search"){
                    cls += " result-container--small";
                }
            }
        if(tool !== ""){
            if(tool === "measure"){
                if(cls.indexOf("large") !== -1){                
                    cls = cls.replace("large", "med");
                }else{                
                    cls += " result-container--med";
                }
            }
            if(tool === "identify"){
                cls += " result-container--large";
            }
        }
    }
        return cls;
    }
    zoomToResults(queryId) {
        const query = this.props.query[queryId];
        const extent = this.getExtentForQuery(query.results);
        this.props.actions.zoomToExtent(extent);
    }
    toggleTable(queryId) {
        this.props.actions.toggleTablePanel();
        setTimeout(() => {
            this.zoomToResults(queryId);
        }, 10);
    }
    CheckResults() {
        if ((this.props.query.order === undefined) || (Array.isArray(this.props.query.order) && this.props.query.order.length === 0)) {
            if(this.props.tool !== "measure"){
                return <p className="centered"><em>Results will render here.</em></p>
            }else{
                return null;
            }
        } else {
            const keys = this.props.query.order;
            return keys.map((key) => {
                if (this.props.query[key].progress === "finished") {
                    let itemsCount = 0;
                    let results = this.props.query[key].layers.map((layer) => {
                        return this.props.query[key].results[layer].map((item) => {
                            if (item.type === "Feature") {
                                itemsCount++;
                                return <LoadableResultItem key={item.properties.gid} data={item.properties} app={this.props.app} />;
                            }
                        });
                    });
                    return <div className="service-accord" key={key} >
                        <div className="__title" onClick={this.toggleContent}>
                            <h3>{this.props.query[key].service} Results <small>({itemsCount})</small></h3>
                            <div className="btn-group btn-group-justify">
                                <button className="btn btn-info" onClick={(e) => { e.stopPropagation(); this.removeQuery(key) }}>
                                    <i title="Clear Results" className="fas fa-trash" />
                                </button>
                                <button className="btn btn-info mobile--hidden" onClick={(e) => { e.stopPropagation(); this.toggleTable(key) }}>
                                    <i title="Toggle Table" className="fas fa-table " />
                                </button>
                                <button className="btn btn-info" onClick={(e) => { e.stopPropagation(); this.zoomToResults(key) }}>
                                    <i title="Zoom To All Results" className="fas fa-compress-arrows-alt" />
                                </button>
                                <button className="btn btn-info" onClick={(e) => { e.stopPropagation(); this.toggleContent() }}>
                                    {this.state.expanded === true ? <i className="fas fa-caret-down" /> : <i className="fas fa-caret-right" />}
                                </button>
                            </div>

                        </div>
                        <div className={this.getContentClass()} style={{ maxHeight: this.props.height + 'px' }}>
                            {results}
                        </div>
                    </div>;
                }
                else {
                    return <p key={key}><em>Fetching...</em></p> // change to loading icon
                }
            });
        }
    }
    render() {
        return (
            <div className="Accord RenderedResults">
                {this.CheckResults()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        'query': state.query,
        tab: state.layout.tab,
        isServiceExpanded: state.layout.expanded,
        tool: state.layout.tool,
        height: state.layout.height
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: {
            toggleTablePanel: () => dispatch(toggleTablePanel()),
            setActiveTab: (tab = "tools") => dispatch(setActiveTab(tab)),
            zoomToExtent: (extent = []) => dispatch(zoomToExtent(extent)),
            removeQuery: (queryId = "") => dispatch(removeQuery(queryId))
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(RenderedResults);